import { createContext, useContext } from "react";

import type { PaymentMethod } from "~/providers/payment-method-provider";

interface PaymentMethodContext {
  paymentMethods: PaymentMethod[];
  softPosEnabled: boolean;
  mollieT2PEnabled: boolean;
  setSoftPosEnabled: (enabled: boolean) => void;
  setMollieT2PEnabled: (enabled: boolean) => void;
}

export const PaymentMethodContext = createContext<
  PaymentMethodContext | undefined
>(undefined);

export const usePaymentMethod = () => {
  const context = useContext(PaymentMethodContext);

  if (context === undefined) {
    throw new Error(
      "usePaymentMethod must be used within a PaymentMethodProvider, but no provider was found",
    );
  }

  return context;
};
